import { render, staticRenderFns } from "./Shutdown.vue?vue&type=template&id=fcd81acc&"
import script from "./Shutdown.vue?vue&type=script&lang=js&"
export * from "./Shutdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports